import { ICON_DEFAULT_COLOR } from '@constants/icons';
import { IconProps } from '@models/icons';

function MobileLine({ size = 16, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <rect x="4" y="2" width="8" height="12" rx="1" stroke={color} strokeWidth="1.4"/>
            <circle cx="8" cy="11" r="1" fill={color}/>
        </svg>
    );
}

export default MobileLine;
